import { render, staticRenderFns } from "./ImsUserSearchDialog.vue?vue&type=template&id=ef0f5332&scoped=true&"
import script from "./ImsUserSearchDialog.vue?vue&type=script&lang=js&"
export * from "./ImsUserSearchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0f5332",
  null
  
)

export default component.exports